import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const pulsate = keyframes`
  0% {transform: scale(0.1, 0.1); opacity: 0.0;}
  50% {opacity: 1.0;}
  100% {transform: scale(1.2, 1.2); opacity: 0.0;}
`;

const RingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 24px;
  height: 24px;
`;

export const Circle = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${(props) => props.color || 'var(--colorUIGreen)'};
  border-radius: 50%;
  z-index: 1;
`;

const RingRing = styled.div`
  border: 3px solid var(--colorUIGreen);
  border-radius: 50%;
  height: 16px;
  width: 16px;
  position: absolute;
  animation: ${pulsate} 2s ease-out infinite;
  opacity: 0;
`;

/* Use Case:
- Can be used as a "Live" indicator, one usage is if a competition is live, this component can be used to indicate that.
*/

const PulsatingCircle = () => (
  <RingContainer>
    <RingRing />
    <Circle />
  </RingContainer>
);

export default PulsatingCircle;
